import React, { useContext, useEffect } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import Dashboard from '../components/dashboard/Dashboard';
import DashboardAlt from '../components/dashboard-alt/DashboardAlt';
import NavbarTop from '../components/navbar/NavbarTop';
import NavbarVertical from '../components/navbar/NavbarVertical';
import Footer from '../components/footer/Footer';
import loadable from '@loadable/component';
import AppContext from '../context/Context';
import SidePanelModal from '../components/side-panel/SidePanelModal';
import { getPageName } from '../helpers/utils';

const DashboardRoutes = loadable(() => import('./DashboardRoutes'));

const DashboardLayout = () => {
  const location = useLocation();
  const { isFluid, isVertical, navbarStyle, isAuthenticated } = useContext(AppContext);

  const isKanban = getPageName('kanban');
  // ?kiosk shows the page without navbars and footer, for infoscreens (see Marktbild)
  const isKiosk = new URLSearchParams(location.search).has('kiosk');

  useEffect(() => {
    DashboardRoutes.preload();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  if (!isAuthenticated) {
    return <Navigate to="/authentication/basic/login" replace />;
  }

  return (
    <div className={isFluid || isKanban || isKiosk ? 'container-fluid' : 'container'}>
      {isVertical && !isKiosk && <NavbarVertical isKanban={isKanban} navbarStyle={navbarStyle} />}

      <div className="content">
        {!isKiosk && <NavbarTop />}
        <Routes>
          <Route path="/" element={<DashboardAlt />} />
          <Route path="/dashboard-alt" element={<DashboardAlt />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/*" element={<DashboardRoutes />} />
        </Routes>
        {!isKanban && !isKiosk && <Footer />}
      </div>
      <SidePanelModal path={location.pathname} />

    </div>
  );
};

export default DashboardLayout;
